import React from "react";
import { EntityType } from "../../PhotoManager/API/api";
import { TabType } from "../types";

const tagIcon = require("../style/tag-icon.svg");

interface Tag {
  id: number;
  name: string;
  photoCount: number;
  type: string;
}

interface TagResultsProps {
  tags: Tag[];
  activeTab: TabType;
  isSingleCategory: boolean;
  onTagClick?: (entityType: EntityType, entityId: number, entityName: string) => void;
  setActiveTab: (tab: TabType) => void;
}

const TagResults: React.FC<TagResultsProps> = ({
  tags,
  activeTab,
  isSingleCategory,
  onTagClick,
  setActiveTab
}) => {
  if (tags.length === 0) return null;

  const handleTagClick = (tag: Tag) => {
    if (onTagClick) {
      onTagClick("tag", tag.id, tag.name);
    }
  };

  const shouldLimit = activeTab === "all" && !isSingleCategory;
  const displayTags = shouldLimit ? tags.slice(0, 5) : tags;
  const showSeeAll = shouldLimit && tags.length > 5;

  return (
    <div className="unified-search-section">
      <h2 className="unified-search-section-title">
        <img
          src={tagIcon}
          alt="Tags"
          className="unified-search-section-icon"
        />
        Tags
      </h2>
      <div className="unified-search-tags-grid">
        {displayTags.map(tag => (
          <button
            key={tag.id}
            type="button"
            className="unified-search-tag-card"
            onClick={() => handleTagClick(tag)}
            aria-label={`View photos tagged with ${tag.name}`}
          >
            {tag.name}
          </button>
        ))}
      </div>
      {showSeeAll && (
        <button
          className="unified-search-see-all"
          onClick={() => setActiveTab("tags")}
        >
          See all
        </button>
      )}
    </div>
  );
};

export default TagResults;
